import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export const requestExistingAccounts = () => noPortalApiClient.get('hub-signup/v1/accounts/cross-hublet', {
  query: {
    includePins: false,
    includeStats: true
  }
});